export const GOOGLE_MAPS_API_KEY = "AIzaSyAIi9VofiuO9Ta-neSgI7C1UAGMWmb56So";
